import { render, staticRenderFns } from "./ServiceAttentionQuote.vue?vue&type=template&id=b6c0dafc"
import script from "./ServiceAttentionQuote.vue?vue&type=script&lang=js"
export * from "./ServiceAttentionQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports